import { render, staticRenderFns } from "./BagianMesinCard.vue?vue&type=template&id=5b27e36e&"
import script from "./BagianMesinCard.vue?vue&type=script&lang=js&"
export * from "./BagianMesinCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports